import { Injectable, inject } from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import {environment} from '../../environments/environment';
import {map} from 'rxjs/operators';
import {AlgemeneMelding, AlgemeneMeldingDto} from './algemene-melding';
import moment from 'moment';


@Injectable({
  providedIn: 'root'
})
export class AlgemeneMeldingService {
  private http = inject(HttpClient);

  getAlgemeneMeldingen$(): Observable<Array<AlgemeneMelding>> {
    const vandaag = moment().format('YYYY-MM-DD');
    const params: HttpParams = new HttpParams().append('dag', vandaag);
    return this.http.get<Array<AlgemeneMeldingDto>>(`${environment.apiUrl}/algemenemeldingen`, {params})
      .pipe(
        map(dtos => dtos.map(dto => AlgemeneMelding.deserialize(dto))),
        map(algemeneMeldingen => algemeneMeldingen.sort(AlgemeneMelding.sortOudsteActiefVanDagEerst)),
      );
  }

  postAlgemeneMelding$(content: string, actiefVanDag: string, actiefTotDag: string): Observable<AlgemeneMelding> {
    return this.http.post<AlgemeneMeldingDto>(`${environment.apiUrl}/algemenemeldingen`,
      {
        content,
        actiefVanDag,
        actiefTotDag
      })
      .pipe(map(dto => AlgemeneMelding.deserialize(dto)));
  }

  putAlgemeneMelding$(id: string, content: string, actiefVanDag: string, actiefTotDag: string): Observable<AlgemeneMelding> {
    return this.http.put<AlgemeneMeldingDto>(`${environment.apiUrl}/algemenemeldingen/${id}`,
      {
        content,
        actiefVanDag,
        actiefTotDag
      })
      .pipe(map(dto => AlgemeneMelding.deserialize(dto)));
  }

  deleteAlgemeneMelding$(id: string): Observable<void> {
    return this.http.delete<void>(`${environment.apiUrl}/algemenemeldingen/${id}`);
  }
}
